import { render, staticRenderFns } from "./NPCReportHeader.vue?vue&type=template&id=05d51fdb&scoped=true&"
import script from "./NPCReportHeader.vue?vue&type=script&lang=js&"
export * from "./NPCReportHeader.vue?vue&type=script&lang=js&"
import style0 from "./NPCReportHeader.vue?vue&type=style&index=0&id=05d51fdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d51fdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
